import { render } from "./KonvaBrush.vue?vue&type=template&id=30d67e8c"
import script from "./KonvaBrush.vue?vue&type=script&lang=js"
export * from "./KonvaBrush.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__